// trigger build
import appEnv from 'bundles/account-profile/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
